/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import { inject, observer } from 'mobx-react';

import { ContextStore } from 'bernie-core';
import { ErrorBoundary } from 'bernie-view';

import { SearchCriteriaStore, AdvertisingStore } from 'stores';

interface MesoInlineBannerComponentProps {
  context?: ContextStore;
  searchCriteriaStore?: SearchCriteriaStore;
  bannerIndex: number;
  searchResultSize: number;
  advertisingStore?: AdvertisingStore;
}

const mesoInLineBannerConfig = {
  slots: {
    '10': {
      minLength: 12,
      viewLarge: {
        id: 'CL1',
        uci: 'CL1'
      },
      viewMedium: {
        id: 'CL2',
        uci: 'CL2'
      },
      viewSmall: {
        id: 'CL3',
        uci: 'CL3'
      }
    },
    '15': {
      minLength: 17,
      viewLarge: {
        id: 'CL4',
        uci: 'CL4'
      },
      viewMedium: {
        id: 'CL5',
        uci: 'CL5'
      },
      viewSmall: {
        id: 'CL6',
        uci: 'CL6'
      }
    },
    '20': {
      minLength: 22,
      viewLarge: {
        id: 'CL7',
        uci: 'CL7'
      },
      viewMedium: {
        id: 'CL8',
        uci: 'CL8'
      },
      viewSmall: {
        id: 'CL9',
        uci: 'CL9'
      }
    }
  }
};

@inject('context', 'searchCriteriaStore', 'advertisingStore')
@observer
export class MesoInlineBannerComponent extends React.Component<MesoInlineBannerComponentProps> {
  public mesoDisplayAdRefCb = (el: Element) => {
    el && el.addEventListener('mesoAd', this.handleMesoAd);
  };

  public handleMesoAd = (e: CustomEvent) => {
    const el: Element = e.srcElement as Element;
    if (e.detail.code !== 'AD-LOAD-PASS') {
      el.parentElement.style.display = 'none';
    }
  };

  public render() {
    const {
      bannerIndex,
      searchResultSize,
      searchCriteriaStore: {
        searchCriteria: { flightsSearchContext }
      },
      advertisingStore: { clAdsVisible }
    } = this.props;
    const slot = mesoInLineBannerConfig.slots[bannerIndex.toString()];

    return (
      <>
        {slot && searchResultSize >= slot.minLength && (
          <li key={`mesoInlineBanner-${bannerIndex}`} className="uitk-grid uitk-flex-justify-content-center">
            <ErrorBoundary label="meso.display.cl.ads">
              {clAdsVisible && (
                <>
                  {slot.viewLarge && (
                    <meso-display-ad
                      ref={this.mesoDisplayAdRefCb}
                      class="all-b-margin-three meso-display-ad-cl"
                      {...slot.viewLarge}
                    />
                  )}
                  {slot.viewMedium && (
                    <meso-display-ad
                      ref={this.mesoDisplayAdRefCb}
                      class="all-b-margin-three meso-display-ad-cl"
                      {...slot.viewMedium}
                    />
                  )}
                  {slot.viewSmall && (
                    <meso-display-ad
                      ref={this.mesoDisplayAdRefCb}
                      class="all-b-margin-three meso-display-ad-cl"
                      {...slot.viewSmall}
                    />
                  )}
                </>
              )}
            </ErrorBoundary>
          </li>
        )}
      </>
    );
  }
}

export const shouldMesoInlineBannerRender = offerIndex =>
  Object.keys(mesoInLineBannerConfig.slots).indexOf(offerIndex.toString()) > -1;
